export default "__VITE_ASSET__59f15393__"